import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {locale as english} from './i18n/en';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {ServiceService} from "../../services/service.service";
import {Service} from "../../models/service";
import {first} from "rxjs/operators";
import {Services} from "../../models/services";
import {WorkerRechargeCard} from "../models/workerRechargeCard";
import {WorkerRechargeCardService} from "../service/workerRechargeCard.service";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";


@Component({
    selector: 'recharge-card-setup',
    templateUrl: './rechargeCardSetup.component.html',
    styleUrls: ['./rechargeCardSetup.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class RechargeCardSetupComponent implements OnInit {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    services: Service[] = [];
    form: FormGroup;
    rechargeCardSetup: WorkerRechargeCard;
    submitted: boolean = false;
    loadingData: boolean = false;

    constructor(
        public matDialogRef: MatDialogRef<RechargeCardSetupComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        private servicesService: ServiceService,
        private rechargeCardSetupService: WorkerRechargeCardService,
        private formBuilder: FormBuilder,
        translate: TranslateService,
        public _matDialog: MatDialog,
    ) {
        this.loadingData = true;
        this.translationLoader.loadTranslations(polish);
        this.translationLoader.loadTranslations(english);

        this.form = this.formBuilder.group({
            enabled: [false],
            dayOfMonth: [1],
            id: [null],
            items: this.formBuilder.array([]),
        });

        this.servicesService.getAll().pipe(first())
            .subscribe((res: Services) => {
                this.services = res.items;
            });

        this.rechargeCardSetupService.findByUser(_data.user.id).pipe(first())
            .subscribe((res: WorkerRechargeCard) => {
                this.rechargeCardSetup = res;

                this.form.get('enabled').setValue(this.rechargeCardSetup.enabled);
                this.form.get('id').setValue(this.rechargeCardSetup.id);
                this.form.get('dayOfMonth').setValue(this.rechargeCardSetup.dayOfMonth);

                for (let i = 0; i < this.rechargeCardSetup.items.length; i++) {
                    this.addItem();
                    this.items().at(i).get('service').setValue(this.rechargeCardSetup.items[i].service.id);
                    this.items().at(i).get('quantity').setValue(this.rechargeCardSetup.items[i].quantity);
                }

                this.loadingData = false;
            });

    }

    ngOnInit() {

    }

    public items(): FormArray {
        return this.form.get('items') as FormArray;
    }

    newItem(): FormGroup {
        return this.formBuilder.group({
            service: [''],
            quantity: [1],
        });
    }

    public addItem() {
        this.items().push(this.newItem());
    }

    public removeItem(lineIdx: number) {
        this.items().removeAt(lineIdx);
    }

    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        console.log(this.form.value);

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.rechargeCardSetupService.update(this.rechargeCardSetup.id, this.form.value).pipe(first())
            .subscribe(response => {
                console.log(response);
            });
    }
}
